import { decimalToPercentageNumber } from './decimalToPercentage';
import { add, multiply, subtract } from './math';

export const getNewMonthlyEscrowPlusShortage = (
  newMonthlyEscrowAmount: number,
  shortageOrOverageAmount: number,
  spreadMonths: number = 12,
) =>
  shortageOrOverageAmount < 0
    ? add(newMonthlyEscrowAmount, (shortageOrOverageAmount * -1) / spreadMonths)
    : newMonthlyEscrowAmount;

export const getMonthlyEscrowDifferenceNumber = (
  oldMonthlyEscrowAmount: number,
  newMonthlyEscrowAmount: number,
  shortageOrOverageAmount: number,
  decimalPlaces?: number,
  spreadMonths: number = 12,
) => {
  const newMonthlyEscrowWithShortage = getNewMonthlyEscrowPlusShortage(
    newMonthlyEscrowAmount,
    shortageOrOverageAmount,
    spreadMonths,
  );

  return decimalToPercentageNumber(
    subtract(newMonthlyEscrowWithShortage, oldMonthlyEscrowAmount) / oldMonthlyEscrowAmount,
    decimalPlaces,
  );
};

export const getMonthlyEscrowDifference = (
  oldMonthlyEscrowAmount: number,
  newMonthlyEscrowAmount: number,
  shortageOrOverageAmount: number,
  decimalPlaces?: number,
  spreadMonths: number = 12,
) => {
  const difference = getMonthlyEscrowDifferenceNumber(
    oldMonthlyEscrowAmount,
    newMonthlyEscrowAmount,
    shortageOrOverageAmount,
    decimalPlaces,
    spreadMonths,
  );

  if (difference === Infinity) return 'new';
  if (difference > 0) return `+ ${Math.abs(difference)}%`;
  if (difference < 0) return `- ${Math.abs(difference)}%`;
  return '0%';
};

/**
 * The default monthly payment already includes 1/spreadMonths of the shortage.
 * This returns the remaining portion so the borrower can pay off the shortage upfront.
 * E.g. For escrow analysis statements, default paymentAmount includes the 1/12th shortage spread.
 * This is the remaining 11/12ths of the shortage (to pay it off upfront).
 */
export const calculateAdditionalEscrowShortage = (shortageAmount: number, spreadMonths: number = 12): number =>
  multiply(shortageAmount / spreadMonths, spreadMonths - 1);
